import { HttpContextToken } from '@angular/common/http';

export const BASIC_AUTH_CONTEXT = new HttpContextToken<AuthContext>(() => ({ token: '', tenantId: '' }));

export const BYPASS_GLOBAL_HTTP_ERROR_HANDLING = new HttpContextToken<boolean>(() => false);

interface AuthContext {
  token: string;
  tenantId: string;
}
